"use strict";
exports.scroll = {
    '-webkit-overflow-scrolling': 'touch',
    overflow: 'auto'
};
exports.scrollX = {
    '-webkit-overflow-scrolling': 'touch',
    overflowX: 'auto'
};
exports.scrollY = {
    '-webkit-overflow-scrolling': 'touch',
    overflowY: 'auto'
};
/**
 * If you expect a child somewhere down in the tree to scroll
 * you need to tell the browser to prevent a scroll bar here
 */
exports.someChildWillScroll = {
    overflow: 'hidden'
};



//////////////////
// WEBPACK FOOTER
// ./~/csstips/lib/scroll.js
// module id = 256
// module chunks = 0